module.exports = __webpack_public_path__ + "img/svg/pc.ff01c346bd62fad85b7599e92b8eb885.svg";